export default function Loader() {
  return <div className="text-center py-5">جاري التحميل...</div>;
} 